// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3zLjn","content":"Consent_content__1-Ul_","footer":"Consent_footer__bP5jW"};